import React from "react";
import { ChatBubble } from "../DynamicScreen/index";

const ChatRoomUI = ({
  chatRoom,
  user,
  setCurrentDeepLink,
  formData,
  formHandlers,
  handleDeeplink,
  ...props 
}) => {
  const messagesEndRef = React.useRef(null);
  const scrollToBottom = () => {
    return messagesEndRef.current?.scrollIntoView({ behavior: "auto" });
  };

  React.useEffect(() => {
    scrollToBottom();
  }, );
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {(chatRoom.comments || []).map((comment) => (
        <ChatBubble
          handleDeeplink={handleDeeplink}
          setCurrentDeepLink={setCurrentDeepLink}
          isLogoNotRequired={true}
          comment={comment}
          transaction={
            (comment.username_real || comment.email) !== user.userId
              ? "received"
              : "sent"
          }
          {...{ formData, formHandlers, handleDeeplink }}
        />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatRoomUI;
